(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-engagement-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!window.GrowplayCollectionEngagementGallery) {
    window.GrowplayCollectionEngagementGallery = true;

    const getSection = (element) => element.closest('.collection-engagement-gallery');
    const getTriggers = (section) => Array.from(section.querySelectorAll('[data-gallery-trigger]'));

    const showImage = (section, index) => {
      const triggers = getTriggers(section);
      const safeIndex = (index + triggers.length) % triggers.length;
      const trigger = triggers[safeIndex];
      const dialog = section.querySelector('[data-gallery-dialog]');
      const image = dialog.querySelector('[data-gallery-dialog-image]');
      const caption = dialog.querySelector('[data-gallery-dialog-caption]');

      section.dataset.galleryCurrentIndex = String(safeIndex);
      image.src = trigger.dataset.fullImage;
      image.alt = trigger.dataset.alt;
      caption.textContent = trigger.dataset.alt;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-gallery-trigger]');
      const close = event.target.closest('[data-gallery-close]');
      const previous = event.target.closest('[data-gallery-prev]');
      const next = event.target.closest('[data-gallery-next]');

      if (trigger) {
        const section = getSection(trigger);
        const dialog = section.querySelector('[data-gallery-dialog]');
        showImage(section, Number(trigger.dataset.galleryIndex));
        dialog.showModal();
      }

      if (close) {
        close.closest('[data-gallery-dialog]').close();
      }

      if (previous || next) {
        const section = getSection(event.target);
        const currentIndex = Number(section.dataset.galleryCurrentIndex || 0);
        showImage(section, previous ? currentIndex - 1 : currentIndex + 1);
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('[data-gallery-dialog]');

      if (dialog && event.target === dialog) {
        dialog.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      const dialog = document.querySelector('[data-gallery-dialog][open]');

      if (!dialog) {
        return;
      }

      const section = getSection(dialog);
      const currentIndex = Number(section.dataset.galleryCurrentIndex || 0);

      if (event.key === 'ArrowLeft') {
        showImage(section, currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        showImage(section, currentIndex + 1);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  document.querySelectorAll('[data-collection-mobile-filter-drawer]').forEach((drawer) => {
    if (drawer.dataset.drawerReady === 'true') return;

    const summary = drawer.querySelector('[data-collection-mobile-filter-drawer-summary]');
    const closeButton = drawer.querySelector('[data-collection-mobile-filter-drawer-close]');
    const trigger = drawer.closest('.shopify-section').querySelector('[data-collection-mobile-filter-trigger]');
    const mobileViewport = window.matchMedia('(max-width: 798px)');

    const setViewportState = () => {
      drawer.open = mobileViewport.matches === false;
    };

    const syncExpandedState = () => {
      summary.setAttribute('aria-expanded', drawer.open ? 'true' : 'false');
      trigger?.setAttribute('aria-expanded', mobileViewport.matches && drawer.open ? 'true' : 'false');
      if (mobileViewport.matches && drawer.open) {
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
      } else {
        drawer.removeAttribute('role');
        drawer.removeAttribute('aria-modal');
      }
    };

    const closeDrawer = () => {
      drawer.open = false;
      (trigger || summary).focus();
    };

    drawer.addEventListener('toggle', () => {
      syncExpandedState();
      if (mobileViewport.matches && !drawer.open && drawer.contains(document.activeElement)) (trigger || summary).focus();
    });
    trigger?.addEventListener('click', () => {
      drawer.open = true;
      syncExpandedState();
      summary.focus();
    });
    closeButton.addEventListener('click', closeDrawer);
    mobileViewport.addEventListener('change', setViewportState);

    document.addEventListener('keydown', (event) => {
      if (!mobileViewport.matches || !drawer.open || !drawer.isConnected) return;
      if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); }
      if (event.key === 'Tab') {
        const focusable = [...drawer.querySelectorAll('summary, a[href], button, input, select, textarea, [tabindex]')]
          .filter(el => el.tabIndex >= 0 && !el.disabled && el.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    setViewportState();
    drawer.dataset.drawerReady = 'true';
    syncExpandedState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["junior-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('junior-card-gallery')) {
    customElements.define('junior-card-gallery', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.events?.abort();
        this.resize?.disconnect();
      }
      setup() {
        this.events?.abort();
        this.resize?.disconnect();
        const track = this.querySelector('[data-gallery-track]');
        const dots = [...this.querySelectorAll('[data-gallery-dot]')];
        if (!track || dots.length < 2) return;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.querySelector('[data-gallery-dots]').hidden = false;
        const arrows = [...this.querySelectorAll('[data-gallery-prev],[data-gallery-next]')];
        arrows.forEach(arrow => { arrow.hidden = false; });
        let targetIndex = 0;
        const sync = () => {
          const index = Math.max(0, Math.min(dots.length - 1, Math.round(Math.abs(track.scrollLeft) / track.clientWidth)));
          dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        };
        const show = index => {
          targetIndex = (index + dots.length) % dots.length;
          const rtl = getComputedStyle(track).direction === 'rtl';
          track.scrollTo({ left: targetIndex * track.clientWidth * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        arrows.forEach(arrow => arrow.addEventListener('click', () => {
          show(targetIndex + (arrow.hasAttribute('data-gallery-next') ? 1 : -1));
        }, {signal}));
        track.addEventListener('scrollend', () => {
          targetIndex = Math.max(0, Math.min(dots.length - 1, Math.round(Math.abs(track.scrollLeft) / track.clientWidth)));
        }, {signal});
        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => show(i), {signal});
          dot.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = event.key === 'Home' ? 0 : event.key === 'End' ? dots.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + dots.length) % dots.length;
            dots[next].focus({preventScroll:true});
            show(next);
          }, {signal});
        });
        let origin = 0, dragged = false;
        track.addEventListener('pointerdown', event => { origin = event.clientX; dragged = false; }, {signal, passive:true});
        track.addEventListener('pointerup', event => { dragged = Math.abs(event.clientX - origin) > 8; }, {signal, passive:true});
        track.addEventListener('pointercancel', () => { dragged = true; }, {signal, passive:true});
        track.addEventListener('click', event => { if (dragged) { event.preventDefault(); dragged = false; } }, {signal});
        track.addEventListener('scroll', sync, {signal, passive:true});
        this.resize = new ResizeObserver(sync);
        this.resize.observe(track);
        sync();
      }
    });
  }
  if (!window.juniorShowcaseStickyReady) {
    window.juniorShowcaseStickyReady = true;
    let frame, settle;
    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        let bottom = 0;
        document.querySelectorAll('#header, #mobile-header').forEach(header => {
          const rect = header.getBoundingClientRect();
          if (rect.width && rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
        });
        document.querySelectorAll('.jr-showcase').forEach(section => section.style.setProperty('--jr-showcase-header-offset', Math.ceil(bottom) + 'px'));
      });
    };
    window.addEventListener('scroll', () => {
      measure();
      clearTimeout(settle);
      settle = setTimeout(measure, 350);
    }, {passive:true});
    document.addEventListener('transitionend', measure, true);
    window.addEventListener('resize', measure, {passive:true});
    document.addEventListener('shopify:section:load', measure);
    document.addEventListener('junior:results-updated', measure);
    measure();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["junior-indoor-outdoor"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('junior-setting-comparison')) {
    customElements.define('junior-setting-comparison', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.onInput = () => {
          this.style.setProperty('--reveal', `${this.input.value}%`);
          this.input.setAttribute('aria-valuetext', `${this.input.value}% ${this.input.dataset.indoor}, ${100 - this.input.value}% ${this.input.dataset.outdoor}`);
        };
        this.input.addEventListener('input', this.onInput);
        this.querySelector('.jr-settings__control').hidden = false;
        this.dataset.ready = 'true';
        this.onInput();
      }
      disconnectedCallback() { this.input?.removeEventListener('input', this.onInput); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["junior-landing-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('junior-shop-sticky')) {
    customElements.define('junior-shop-sticky', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          const hero = document.getElementById(this.dataset.heroId);
          const button = hero?.querySelector('.junior-collection-hero__actions');
          if (!button || !('IntersectionObserver' in window)) return;
          const destination = new URL(this.querySelector('a').href);
          const alternatives = [...document.querySelectorAll('main a[href], [role="main"] a[href]')].filter(link => {
            if (this.contains(link)) return false;
            const url = new URL(link.href);
            return url.origin === destination.origin && url.pathname === destination.pathname
              && ![...url.searchParams.keys()].some(key => key.startsWith('filter.'));
          });
          let pastHero = false;
          const visible = new Set();
          const sync = () => { this.hidden = !pastHero || visible.size > 0; };
          this.observer = new IntersectionObserver(([entry]) => {
            pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            sync();
          });
          this.alternativesObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= .25) visible.add(entry.target);
              else visible.delete(entry.target);
            });
            sync();
          }, { threshold:[0, .25] });
          alternatives.forEach(link => this.alternativesObserver.observe(link));
          this.observer.observe(button);
        });
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.observer?.disconnect(); this.alternativesObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["junior-layout-animation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const instances = new Map();
    const init = () => document.querySelectorAll('[data-layout-animation]').forEach(root => {
      if (instances.has(root)) return;
      const img = root.querySelector('img');
      const state = { allowed: !motion.matches, visible: false, playing: false };
      const update = () => {
        const play = state.allowed && state.visible && !document.hidden;
        if (play !== state.playing) {
          img.src = play ? img.dataset.animation : img.dataset.poster;
          state.playing = play;
        }
      };
      const observer = new IntersectionObserver(entries => {
        state.visible = entries[0].isIntersecting;
        update();
      });
      observer.observe(root);
      instances.set(root, {state, update, observer});
    });
    document.addEventListener('visibilitychange', () => instances.forEach(item => item.update()));
    motion.addEventListener('change', () => instances.forEach(item => { item.state.allowed = !motion.matches; item.update(); }));
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', event => instances.forEach((item,root) => {
      if (event.target.contains(root)) { item.observer.disconnect(); instances.delete(root); }
    }));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["junior-product-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('junior-feature-story')) {
    customElements.define('junior-feature-story', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-feature]')];
        if (!this.items.length) return;
        this.panels = [...this.querySelectorAll('[data-media]')];
        this.control = this.querySelector('[data-pause]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 799px)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.paused = false;
        this.visible = false;
        this.hovered = false;
        this.active = 0;
        this.elapsed = 0;
        this.duration = Number(this.dataset.interval) || 8000;
        this.editor = this.dataset.editor === 'true';
        this.items.forEach((item, index) => {
          item.querySelector('summary').addEventListener('click', event => {
            event.preventDefault();
            this.paused = item.querySelector('summary').matches(':focus-visible');
            this.select(index);
          }, options);
        });
        this.control.addEventListener('click', () => { this.paused = this.control.getAttribute('aria-pressed') !== 'true'; this.manualPlay = !this.paused; this.sync(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', event => { if (event.target !== this.control && event.target.matches(':focus-visible')) this.paused = true; this.sync(); }, options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.sync()), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.feature === event.detail.blockId);
          if (index >= 0) { this.paused = true; this.select(index); }
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => { this.manualPlay = false; this.sync(); }, options);
        this.desktop.addEventListener('change', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25; this.sync(); }, { threshold: [0, 0.25] });
        this.observer.observe(this.querySelector('.junior-product-benefits__media'));
        this.select(0);
      }
      select(index) {
        this.stopClock();
        this.elapsed = 0;
        this.active = index;
        this.manualPlay = false;
        this.items.forEach((item, i) => { item.open = i === index; });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
        this.sync();
      }
      sync() {
        this.stopClock();
        const cycle = this.dataset.autoplay === 'true' && this.desktop.matches && !this.motion.matches && this.items.length > 1;
        const activeVideo = this.panels[this.active].querySelector('video');
        const available = this.visible && !document.hidden && !this.paused;
        const mediaCanRun = available && (this.manualPlay || !this.motion.matches);
        this.panels.forEach((panel, i) => {
          const video = panel.querySelector('video');
          if (!video) return;
          if (i === this.active && mediaCanRun) video.play().catch(() => {});
          else video.pause();
        });
        this.control.hidden = !cycle && !activeVideo;
        const stopped = this.paused || (!this.manualPlay && this.motion.matches);
        this.control.setAttribute('aria-pressed', String(stopped));
        this.control.setAttribute('aria-label', stopped ? this.control.dataset.playLabel : this.control.dataset.pauseLabel);
        this.control.querySelector('[data-pause-text]').hidden = stopped;
        this.control.querySelector('[data-play-text]').hidden = !stopped;
        this.style.setProperty('--feature-progress', cycle ? Math.min(this.elapsed / this.duration, 1) : 1);
        const focusBlocksCycle = document.activeElement !== this.control && this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        if (cycle && available && (!this.hovered || this.manualPlay) && !focusBlocksCycle) {
          this.startedAt = performance.now();
          this.tick = requestAnimationFrame(now => this.advanceClock(now));
        }
      }
      stopClock() {
        cancelAnimationFrame(this.tick);
        if (this.startedAt != null) this.elapsed += performance.now() - this.startedAt;
        this.startedAt = null;
      }
      advanceClock(now) {
        const elapsed = this.elapsed + now - this.startedAt;
        this.style.setProperty('--feature-progress', Math.min(elapsed / this.duration, 1));
        if (elapsed >= this.duration) this.select((this.active + 1) % this.items.length);
        else this.tick = requestAnimationFrame(time => this.advanceClock(time));
      }
      disconnectedCallback() {
        this.stopClock();
        this.abort?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
